import { MANAGE_ROUTE_NAME } from '@/libs/route-name';
import type { RouteRecordRaw } from 'vue-router';

export const manageRoute: RouteRecordRaw = {
    path: '',
    name: MANAGE_ROUTE_NAME.MANAGE,
    component: () => import('@/pages/manage/index.vue'),
};